import type { Message, ReferenceItem } from "../../api/types.js";

export function referenceIdentity(reference: Partial<ReferenceItem> | null | undefined) {
  return String(reference?.webSourceId || reference?.id || reference?.poolId || "");
}

export function mergeReferenceEntities(items: ReferenceItem[], incoming: ReferenceItem | ReferenceItem[]) {
  const next: ReferenceItem[] = [];
  for (const item of [...(items || []), ...(Array.isArray(incoming) ? incoming : [incoming])]) {
    if (!referenceIdentity(item)) continue;
    const index = next.findIndex((candidate) => (
      Boolean(item.id && candidate.id && item.id === candidate.id)
      || Boolean(item.webSourceId && candidate.webSourceId && item.webSourceId === candidate.webSourceId)
      || Boolean(item.poolId && candidate.poolId && item.poolId === candidate.poolId)
    ));
    if (index >= 0) next[index] = { ...next[index], ...item };
    else next.push(item);
  }
  return next;
}

export function citedSourcesForMessage(message: Message | null, citationSources: ReferenceItem[]) {
  if (!message) return [];
  const byId = new Map(citationSources.filter((source) => source.id).map((source) => [String(source.id), source]));
  const byWebSourceId = new Map(citationSources.filter((source) => source.webSourceId).map((source) => [String(source.webSourceId), source]));
  const byPoolId = new Map(citationSources.filter((source) => source.poolId).map((source) => [String(source.poolId), source]));
  return [...(message.meta?.citationMap || [])]
    .sort((a: any, b: any) => Number(a.localIndex || 0) - Number(b.localIndex || 0))
    .flatMap((entry: any) => {
      const source = (entry.referenceItemId && byId.get(String(entry.referenceItemId)))
        || (entry.webSourceId && byWebSourceId.get(String(entry.webSourceId)))
        || byPoolId.get(String(entry.poolId || ""));
      if (!source) return [];
      const localIndex = Number(entry.localIndex || 0);
      return [{
        ...source,
        index: localIndex,
        citationIndex: localIndex,
        ...(source.sourceType === "web" ? { verification: undefined } : { verification: entry.verification })
      } satisfies ReferenceItem];
    });
}
